import { request } from "./request.js";

async function get() {
    return await request("/home", {}, "POST");
}

export { get };
